import {SvgIcon} from "@material-ui/core";

export const CustomFeatherIcon = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path d="M13.4933 8.15998C14.2439 7.40942 14.6656 6.39144 14.6656 5.32998C14.6656 4.26853 14.2439 3.25055 13.4933 2.49998C12.7428 1.74942 11.7248 1.32776 10.6633 1.32776C9.60189 1.32776 8.58391 1.74942 7.83334 2.49998L3.33334 6.99998V12.6666H9.00001L13.4933 8.15998Z" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.6667 5.33337L1.33334 14.6667" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.6667 10H6" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
    )
}
